<template>
  <div class="header">
    <Asset
      class="header-logo"
      name="logo.svg"
      alt="Logo Parcelex"
      title="Logo Parcelex"
    />

    <Icon
      v-show="false"
      v-if="showHeaderHelperIcon"
      class="header-icon"
      name="help-gray"
    />
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';
import Icon from '@/components/ui/AppIcon.vue';

export default {
  name: 'step-info-header',
  components: { Asset, Icon },
  props: {
    showHeaderHelperIcon: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .header {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;

    .header-logo {
      width: 140px;
    }
  }
</style>
